import React, {useEffect, useState} from 'react';
import {FormHeading} from "../../shared/components/Typograhy";
import SummaryContainer from "../containers/SummaryContainer";
import {NavBar} from "../../shared/components/NavBar";
import {
    getData,
    getShowAcceptingQuotationSuccess,
    getShowAcceptQuotation,
    getShowPay
} from '../../../data/followup/selectors/followup';
import {useDispatch, useSelector} from "react-redux";
import isEmpty from 'lodash/isEmpty';
import * as quotationStatus from '../../../data/booking/constants/quotation_status';
import * as reservationStatus from '../../../data/booking/constants/reservation_status';
import phone from '../../../data/shared/phoneNumber';
import AcceptQuotationButtonContainer from '../../followup/containers/AcceptQuotationButtonContainer';
import Documents from "./Documents";
import PayButtonContainer from "../containers/PayButtonContainer";
import { fetchData } from '../../../data/followup/actions/followup';
import hikingImage from "../../../theme/img/bg/marcheurs2.jpeg";
import PayBalanceContainer from "../../followup/containers/PayBalanceContainer";
import {useTranslation} from "react-i18next";
import AcceptQuotationFormContainer from "../../followup/containers/AcceptQuotationFormContainer";
import AcceptQuotationSuccessContainer from "../../followup/containers/AcceptQuotationSuccessContainer";
import {Alert} from "../../shared/components/Alert";

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {isEditable} from "../../../data/followup/selectors/followup";
import {Link, useNavigate} from "react-router-dom";
import {generate} from "../../../routing/routes";
import {CancelButton, EditButton, OrangeButton} from "../../shared/components/Buttons";
import Tooltip from "../../shared/components/Tooltip";
import EditButtonContainer from "../../followup/containers/EditButtonContainer";
import {submitUpdateCancellation} from "../../../data/followup/actions/followup";

const getEndUserName = (endUser) => {
    if (!isEmpty(endUser.firstName) && !isEmpty(endUser.lastName)) {
        return endUser.firstName + ' ' + endUser.lastName;
    }

    if (!isEmpty(endUser.firstName) && isEmpty(endUser.lastName)) {
        return endUser.firstName;
    }

    return endUser.lastName;
};

const EndUser = ({ endUser }) =>
    <div className="end-user">
        {getEndUserName(endUser)}<br />
        {!isEmpty(endUser.email) && endUser.email}<br />
        {!isEmpty(endUser.phoneNumber) && phone.formatString(endUser.phoneNumber)}
    </div>
;

const Status = ({ data }) => {
    if ('quotation' == data.type || "pending_customer_confirmation" == data.type) {
        return <div className="w-fit flex items-center gap-2 px-3 py-1 rounded-full text-gray-600 font-semibold bg-gray-100">
            <span className="inline-block w-2 h-2 bg-gray-300 rounded-full"></span>
            {quotationStatus.statusName(data.status)}
        </div>
    }

    return <div className="w-fit flex items-center gap-2 px-3 py-1 rounded-full text-gray-600 font-semibold bg-gray-100">
        <span className="inline-block w-2 h-2 bg-gray-300 rounded-full"></span>
        {reservationStatus.statusName(data.status)}
    </div>
};

const Followup = ({params, searchParams}) => {
    const data = useSelector(state=>getData(state.followup));
    const isFetching = useSelector(state=> state.followup.followup.isFetching);
    const isCancelingUpdateRequest = useSelector(state=> state.followup.followup.isCancelingUpdateRequest);
    const acceptQuotationSuccess = useSelector(state=> getShowAcceptingQuotationSuccess(state.followup));
    const showAcceptQuotation = useSelector(state=> getShowAcceptQuotation(state.followup));
    const showPay = useSelector(state=> getShowPay(state.followup));
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const pendingUpdate = data && !isEmpty(data.pendingServices)
    const navigate = useNavigate()

    const showPaymentSuccess = searchParams.has('payment_success');
    const showPaymentFailure = searchParams.has('payment_refused');

    useEffect(() => {
        dispatch(fetchData(params.reference));
    }, []);

    const tabs = [
        { name: 'Détail', href: 'reservation', component: SummaryContainer },
        { name: 'Documents', href: 'documents', component: Documents},
    ];
    const [selectedTab, setSelectedTab] = useState(tabs[0].href);

    return (
        <div>

            {showPay && <PayBalanceContainer />}
            {showAcceptQuotation && <AcceptQuotationFormContainer />}
            {acceptQuotationSuccess && <AcceptQuotationSuccessContainer />}
            {isFetching ?
            <div className="overflow-hidden rounded-xl border border-gray-100 shadow-lgflex">
                <div className="h-[50vh] overflow-hidden rounded-xl border border-gray-100 shadow-lg flex justify-center items-center">
                    <FontAwesomeIcon icon={faCircleNotch} className={"h-10 w-10 text-gray-300 self-center"} spin />
                    <p className="ml-4 text-lg text-gray-800">{t('shared.loading')}</p>
                </div>
            </div> : <>
            <FormHeading title={'quotation' == data.type ? `${t('followup.your_request')}` : `${t('followup.your_reservation')}`} />
                {(showPaymentSuccess || showPaymentFailure) && <Alert alert={showPaymentSuccess ? 'success' : 'danger'} >
                    {showPaymentSuccess &&
                        <p>{t('followup.payment_message')}</p>
                    }

                    {showPaymentFailure &&
                        <div>
                            <p className="mb-3 font-bold">
                                <i className="fa fa-exclamation-triangle mr-2"/>{t('followup.payment_error_title')}
                            </p>
                            <p className="mb-1">{t('followup.payment_error_information_1')}</p>
                            <p className="mb-1">{t('followup.payment_error_information_2')}</p>
                        </div>
                    }
                </Alert>}

            <div className="my-10">
                <div
                    className="
                overflow-hidden rounded-xl border border-gray-100 shadow-lg
                lg:flex lg:flex-row-reverse
            "
                >
                    <div className={"lg:w-7/12"}>
                        <div
                            className={
                                "aspect-w-8 aspect-h-3 h-full w-full rounded-lg bg-cover bg-center lg:rounded-none"
                            }
                            style={{
                                backgroundImage: data.mainRoute.picture ? `url(${data.mainRoute.picture})` : `url(${hikingImage})`
                            }}
                        ></div>
                    </div>
                    <div className={"lg:w-5/12 px-12 py-8"}>
                        <div className="mt-4 items-start justify-between lg:mt-0">
                            <div className="w-full lg:mb-4">

                                <p className="text-sm font-bold text-gray-800 lg:text-xl">
                                    n° #{data.reference}
                                </p>
                                <div className="flex flex-col text-gray-800">
                                    {(data.clientData.id || data.clientData.mail) &&
                                        <span className="w-1/2 h-px bg-gray-400 mt-2 mb-1"></span>
                                    }
                                    {(data.clientData.id) && <p>
                                        {data.clientData.id}
                                    </p>}
                                    {(data.clientData.mail) && <p>
                                        {data.clientData.mail}
                                    </p>}
                                    {(data.clientData.id || data.clientData.mail) &&
                                        <span className="w-1/2 h-px bg-gray-400 mb-2 mt-1"></span>
                                    }
                                </div>
                                {data.endUser &&
                                    <EndUser endUser={data.endUser}/>
                                }

                                {<div className="mt-4"><Status data={data} /></div>}
                            </div>
                            {pendingUpdate && <Alert alert="warning">
                                <div className="items-center text-center">
                                    <p className={"mb-2 text-left"}>{t('quotation' == data.type ? 'booking.update.quotation.information' : 'booking.update.reservation.information')}</p>
                                    <div className={"text-center flex flex-col sm:flex-row gap-2 justify-center"}>
                                        <Tooltip content={t('booking.update.abandon.information')} Icon={null}>
                                            <CancelButton loading={isCancelingUpdateRequest} disabled={isCancelingUpdateRequest} onClick={()=>{
                                                dispatch(submitUpdateCancellation(params.reference)).then(()=>{
                                                    dispatch(fetchData(params.reference));
                                                })
                                            }} >{t("booking.update.abandon")}</CancelButton>
                                        </Tooltip>
                                        {isEditable(data) && <Tooltip content={t('booking.update.addedit.information')} Icon={null}>
                                            <EditButtonContainer data={data} />
                                        </Tooltip>}
                                    </div>
                                </div>
                            </Alert>}
                            <div className="mt-4 flex gap-x-2 items-center justify-center">
                                {!pendingUpdate && <EditButtonContainer data={data} />}
                                {'reservation' == data.type && data.status != 'cancelled' && <PayButtonContainer/>}
                                {!pendingUpdate && <AcceptQuotationButtonContainer/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NavBar tabs={tabs} currentTab={selectedTab} onClick={setSelectedTab}/>
            {tabs.filter(tab=>tab.href == selectedTab).map(tab =>
            <div key={tab.href} className="mb-10" id={tab.href} >
                <tab.component />
            </div>)}
            </>}
        </div>
    );
};
export default Followup;